import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=7a4df3a2&scoped=true&"
import script from "./ProfileSettings.vue?vue&type=script&lang=js&"
export * from "./ProfileSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettings.vue?vue&type=style&index=0&id=7a4df3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4df3a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4df3a2')) {
      api.createRecord('7a4df3a2', component.options)
    } else {
      api.reload('7a4df3a2', component.options)
    }
    module.hot.accept("./ProfileSettings.vue?vue&type=template&id=7a4df3a2&scoped=true&", function () {
      api.rerender('7a4df3a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProfileSettings.vue"
export default component.exports